import { render, staticRenderFns } from "./WalletTransactionDetail.vue?vue&type=template&id=6233fc57"
import script from "./WalletTransactionDetail.vue?vue&type=script&lang=js"
export * from "./WalletTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./WalletTransactionDetail.vue?vue&type=style&index=0&id=6233fc57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports